import React from 'react';
import { Building, CreditCard, Shield, Bell, Users } from 'lucide-react';
export function Settings() {
  return <div className="space-y-8 animate-in fade-in duration-500 max-w-4xl" data-id="element-2437" data-mp="2j8jss1bvkn98">
      <div data-id="element-2438" data-mp="24ahr5woembum">
        <h1 className="text-2xl font-semibold text-slate-900" data-id="element-2439" data-mp="24b17xa2biu72">Settings</h1>
        <p className="text-slate-500 mt-1" data-id="element-2440" data-mp="299cdv9phskk0">
          Manage your organization and personal preferences.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8" data-id="element-2441" data-mp="2wyncolna84vi">
        {/* Settings Nav */}
        <div className="w-full md:w-64 shrink-0" data-id="element-2442" data-mp="31yjdyd4lhi7d">
          <nav className="space-y-1" data-id="element-2443" data-mp="31x8egpi6mwm2">
            <a href="#" className="flex items-center px-3 py-2.5 bg-slate-100 text-slate-900 rounded-md text-sm font-medium" data-id="element-2444" data-mp="2n9dkz6wcoo7x">
              <Building className="h-4 w-4 mr-3 text-slate-700" data-id="element-2445" data-mp="2s63vlepdyrly" />
              Organization
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2446" data-mp="3fvy7nu1vsc55">
              <Users className="h-4 w-4 mr-3 text-slate-400" data-id="element-2447" data-mp="3j8pp0efs5jyb" />
              Members & Roles
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2448" data-mp="1ry7lq6b4h2w">
              <Shield className="h-4 w-4 mr-3 text-slate-400" data-id="element-2449" data-mp="as3d1urxx5ef" />
              Permissions
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2450" data-mp="5ukzts6w440m">
              <Bell className="h-4 w-4 mr-3 text-slate-400" data-id="element-2451" data-mp="ftakttu324l3" />
              Notifications
            </a>
            <a href="#" className="flex items-center px-3 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900 rounded-md text-sm font-medium transition-colors" data-id="element-2452" data-mp="2mj8dvjy135p8">
              <CreditCard className="h-4 w-4 mr-3 text-slate-400" data-id="element-2453" data-mp="3792maeh9apoh" />
              Billing & Plans
            </a>
          </nav>
        </div>

        {/* Settings Content */}
        <div className="flex-1 space-y-6" data-id="element-2454" data-mp="3g74pn0ogpuex">
          <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2455" data-mp="3gaiucfklmfpj">
            <div className="p-6 border-b border-slate-200" data-id="element-2456" data-mp="3l4whjup3xgj4">
              <h2 className="text-lg font-medium text-slate-900" data-id="element-2457" data-mp="3q5kib8351bqj">
                Organization Profile
              </h2>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2458" data-mp="3u64heh79upfb">
                Update your company details and branding.
              </p>
            </div>
            <div className="p-6 space-y-6" data-id="element-2459" data-mp="7sw3obgg41vq">
              <div className="flex items-center space-x-6" data-id="element-2460" data-mp="7rl12eyql067">
                <div className="w-20 h-20 bg-slate-100 border border-slate-200 rounded-lg flex items-center justify-center text-slate-400" data-id="element-2461" data-mp="cs8rozj1zezw">
                  <Building className="h-8 w-8" data-id="element-2462" data-mp="hqsdmzxncqs9" />
                </div>
                <div data-id="element-2463" data-mp="229mi8j803ncq">
                  <button className="bg-white border border-slate-200 text-slate-700 px-3 py-1.5 rounded-md text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-2464" data-mp="229w6o2dedmgb">
                    Upload Logo
                  </button>
                  <p className="text-xs text-slate-500 mt-2" data-id="element-2465" data-mp="1sc88t3khvytx">
                    JPG, GIF or PNG. 1MB max.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-6" data-id="element-2466" data-mp="2kyaxaojsyygl">
                <div data-id="element-2467" data-mp="2fzg731jia7mg">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2468" data-mp="2g1ar8dmydvph">
                    Organization Name
                  </label>
                  <input type="text" defaultValue="Acme Corp" className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-2469" data-mp="26a6c9dxa2aun" />
                </div>
                <div data-id="element-2470" data-mp="2jgawx0jt1mcu">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2471" data-mp="2jg165aqxrb63">
                    Industry
                  </label>
                  <select className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm bg-white" data-id="element-2472" data-mp="2odkj87bwdhwg">
                    <option data-id="element-2473" data-mp="2eju0lj2gc1oo">Technology</option>
                    <option data-id="element-2474" data-mp="327235t8hwwn0">Healthcare</option>
                    <option data-id="element-2475" data-mp="329etatoeqdb5">Finance</option>
                    <option data-id="element-2476" data-mp="376og01kewava">Manufacturing</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end" data-id="element-2477" data-mp="2sgzaxv977mpq">
              <button className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-id="element-2478" data-mp="2xf0uehajdo1q">
                Save Changes
              </button>
            </div>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2479" data-mp="3pyzg5nnolupp">
            <div className="p-6 border-b border-slate-200" data-id="element-2480" data-mp="1efuifx19r6wz">
              <h2 className="text-lg font-medium text-slate-900" data-id="element-2481" data-mp="19ht41pesfvru">
                Subscription Plan
              </h2>
              <p className="text-sm text-slate-500 mt-1" data-id="element-2482" data-mp="1o77el0u3oj8t">
                Manage your current tier and features.
              </p>
            </div>
            <div className="p-6" data-id="element-2483" data-mp="vitbw7s2gyqx">
              <div className="flex items-center justify-between p-4 border border-indigo-100 bg-indigo-50 rounded-lg" data-id="element-2484" data-mp="vjupaiwk1xbt">
                <div data-id="element-2485" data-mp="qlt7e1av841x">
                  <div className="font-semibold text-indigo-900" data-id="element-2486" data-mp="qmbclnfi9slz">
                    Enterprise Tier
                  </div>
                  <div className="text-sm text-indigo-700 mt-1" data-id="element-2487" data-mp="10hmtabah59wd">
                    Includes AI Coaching & Benchmarking
                  </div>
                </div>
                <button className="bg-white border border-indigo-200 text-indigo-700 px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-50 transition-colors" data-id="element-2488" data-mp="2g0ra5r8exv66">
                  Manage Plan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}